import { apiPost } from './client';

export async function requestReset(email: string): Promise<void> {
  await apiPost<void>('/auth/password_reset/request/', { email });
}

export async function confirmReset(
  code: string,
  newPassword: string,
): Promise<{ ok: boolean; tokens_revoked: number }> {
  return apiPost('/auth/password_reset/confirm/', { code, new_password: newPassword });
}
